import { NgModule } from "@angular/core";
import { UploadFilesComponent } from "./upload-files/upload-files.component";
import { ButtonModule } from "primeng/button";
import { FileUploadModule } from 'primeng/fileupload';
import { TableModule } from "primeng/table";
import { ToastModule } from "primeng/toast";
import { CommonModule } from "@angular/common";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatProgressBarModule } from "@angular/material/progress-bar";

@NgModule({
    declarations:[
        UploadFilesComponent
    ],
    imports: [
        ButtonModule,
        FileUploadModule,
        TableModule,
        ToastModule,
        CommonModule,
        MatProgressSpinnerModule,
        MatProgressBarModule
    ],
    exports: [
        UploadFilesComponent
    ]
})
export class UploadModule { }